import { useObjectContext } from '@context/ItemZoneContext'
import { dictionary } from '@context/utils/shared'
import { useAppStore } from '@store'
import { Textures } from '@types'
import clsx from 'clsx'
import { ReactNode } from 'react'

type Props = { children?: ReactNode }
export function ObjectZonesEditor({ children }: Props) {
  const t = useAppStore.use.t()
  const {
    object,
    currentTexture,
    copiedIconId,
    pasteIcons,
    actions: { handlePaste, handleZoneClick, handleCopy },
  } = useObjectContext()

  if (!object.current) return null
  if (!currentTexture) return null
  const textures = object.current.textures

  return (
    <>
      <article className='flex h-[140px] flex-col'>
        <div className='scrollable-editor max-h-[165px] overflow-auto'>
          {textures.map((texture: Textures[number], i: number) => {
            return (
              <div
                key={i}
                onClick={() => {
                  handleZoneClick(texture)
                }}
                className={clsx(
                  'hover-bg-C/Color2 h-[36px] cursor-pointer border-b border-C/Color2 p-0.5',
                  texture.zoneName === currentTexture.zoneName && 'bg-C/Color2 pt-1',
                )}
              >
                <div className='flex'>
                  <div className='max-w-[180px]  overflow-hidden text-ellipsis whitespace-nowrap'>
                    {t(texture.zoneDisplayName)}
                  </div>
                  <div className=' ml-2'>
                    <p className='text-[10px] font-bold'>{`(${t(texture.id)})`}</p>
                    <p className='max-w-[100px] overflow-hidden text-ellipsis whitespace-nowrap text-[10px] font-bold'>
                      {t(texture.name)}
                    </p>
                  </div>
                  <img
                    src={
                      copiedIconId === texture.zoneName
                        ? dictionary['canCopy']
                        : dictionary['cantCopy']
                    }
                    alt='icon copy'
                    className='m-auto mr-2 h-[20px]'
                    onClick={(e) => handleCopy(texture, e)}
                  />
                  <img
                    src={dictionary[pasteIcons[texture.zoneName]]}
                    alt='icon paste'
                    className='mr-2 mt-[6px] h-[20px]'
                    onClick={(e) => handlePaste(e, texture.zoneName)}
                  />
                </div>
              </div>
            )
          })}
        </div>
      </article>
      {children}
    </>
  )
}
